import { UseFormReturn } from 'react-hook-form';

export const getCommonValidationRules = (formMethods: UseFormReturn<any>): Record<string, any> => ({
  firstName: { required: 'Ce champ est requis' },
  lastName: { required: 'Ce champ est requis' },
  addressNumber: {
    validate: (value: string) => {
      const addressType = formMethods.watch('addressType');
      if (addressType !== 'ldit' && !value) {
        return 'Ce champ est requis';
      }
      return true;
    },
  },
  addressType: { required: 'Ce champ est requis' },
  addressName: { required: 'Ce champ est requis' },
  city: { required: 'Ce champ est requis' },
  postalCode: { required: 'Ce champ est requis' },
  country: { required: 'Ce champ est requis' },
});

export const getProValidationRules = (formMethods: UseFormReturn<any>): Record<string, any> => ({
  ...getCommonValidationRules(formMethods),
  siret: { required: 'Ce champ est requis' },
  companyName: { required: 'Ce champ est requis' },
});
